import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import TagContainer from '@enums/tagContainer';
import { Product } from '@interfaces/models/product';
import { ProductMeshLinksCategory } from '@interfaces/models/productMeshLinks';
import { useAnalytics } from '@context/analytics.context';
import Link from '@components/atoms/link/link';
import styles from './product-categories-suggestions.module.scss';

interface ProductCategoriesSuggestionsProps {
  product?: Product;
}

const ProductCategoriesSuggestions: React.FC<ProductCategoriesSuggestionsProps> = ({ product }) => {
  const { sendEvent } = useAnalytics();
  const { t } = useTranslation();

  const bottomLinks: ProductMeshLinksCategory[] = Object.values(product?.meshLinks ?? {});

  useEffect(() => {
    sendEvent({
      type: 'event',
      container: TagContainer.Analytics,
      payload: {
        event: 'productModuleDisplayPDP',
        productModuleTitle: 'Block-You may also like',
      },
    });
  }, []);

  return (
    <section
      className={styles.product__bottomLinks}
      data-internal-linking="botify"
    >
      <div className="innerContainer">
        <div className={clsx(styles.productBottomLinks__title, 'vc-title-xs')}>
          {t('SUGGESTIONS.YOU_MIGHT_ALSO_LIKE')}
        </div>
        <div className={styles.productBottomLinks__container}>
          {bottomLinks.map((productMeshLinkCategory: ProductMeshLinksCategory) => (
            <Link
              key={productMeshLinkCategory.localizedName}
              href={productMeshLinkCategory.url.path}
              className={clsx(styles.productBottomLinks__link, 'vc-btn vc-btn--secondary vc-btn--small')}
            >
              {productMeshLinkCategory.localizedName}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategoriesSuggestions;
